import React, { useState, useEffect } from 'react';

function ScrollNavigation() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showScrollBottom, setShowScrollBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      
      // Show scroll to top button when scrolled down more than 300px
      setShowScrollTop(scrollTop > 300);
      
      // Show scroll to bottom button when not at the bottom
      // Add a small threshold (20px) to account for rounding issues
      setShowScrollBottom(scrollTop + clientHeight < scrollHeight - 20);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial scroll position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div className="scroll-navigation">
      {showScrollTop && (
        <button 
          className="scroll-button scroll-top" 
          onClick={scrollToTop}
          aria-label="Scroll to top"
          title="Scroll to top"
        >
          ↑
        </button>
      )}
      {showScrollBottom && (
        <button 
          className="scroll-button scroll-bottom" 
          onClick={scrollToBottom}
          aria-label="Scroll to bottom"
          title="Scroll to bottom"
        >
          ↓
        </button>
      )}
    </div>
  );
}

export default ScrollNavigation;
